import { CustomerSensitiveData } from '../../services/auth';
import { ActionInterface } from '../../utils/redux';
import { SensitiveActions } from './constants';
import SensitiveState, { SensitiveStateInterface } from './state';

const INITIAL_STATE = new SensitiveState();

function SensitiveReducer(
  state = INITIAL_STATE,
  action: ActionInterface<SensitiveActions>
): SensitiveStateInterface {
  switch (action.type) {
    case SensitiveActions.setSensitiveData:
      return setSensitiveData(state, action);
    default:
      return state;
  }
}

export default SensitiveReducer;

function setSensitiveData(
  state: SensitiveStateInterface,
  action: ActionInterface<SensitiveActions, CustomerSensitiveData>
) {
  return { ...state, customerSensitiveData: action.payload || {} };
}
